export default {
  overviewTitle: 'Chassis Nummers',
  detailTitle: 'Chassis Nummer',
  deleteTitle: 'dit ChassisNumber',
  url: '/vehicle/chassisnumbers',
  apiUrl: '/chassisnumbers/',
  sortBy: ['chassis_nr'],
  sortDesc: [false],
  deletable: true,
  editable: true,
  filterName: 'vehicle/chassisnumbers',
  quickFilter: {
    text: 'Zoek op chassis_nr, omschrijving',
    value: 'misc_search',
    type: 'text'
  },
  advancedSearchFields: [
    {text: 'Aanhangwagen', value: 'is_trailer', optionList: [{text: 'Ja', value: true}, {text: 'Nee', value: false}]}
    // {text: 'Chauffeur', value: 'driver_id', type: 'optionList', optionListName: 'drivers'},
    // {text: 'Trekker ChassisNr', value: 'truck_chassisnr'},
    // {text: 'Aanhangwagen ChassisNr', value: 'trailer_chassisnr'}
    // {text: 'Periode van', value: 'begin_timestamp_date_ge', type: 'date'},
    // {text: 'Periode tot', value: 'begin_timestamp_date_le', type: 'date'},
    // {text: 'Dossier', value: 'dossier'},
    // {text: 'Niet gefactureerd', value: 'not_invoiced', type: 'boolean'}
  ],
  newRecord: {
    is_trailer: false,
    is_active: true
  },
  // isReadOnlyOverview: true,
  // customEditable(item) {
  //   return false;
  // },
  // customDeletable(item) {
  //   return false;
  // },
  tableFields: [
    {text: 'ChassisNr', value: 'chassis_nr', link: '/vehicle/chassisnumbers/{id}', width: '10%'},
    {text: 'Omschrijving', value: 'description', width: '10%'},
    {text: 'Aanhangwagen', value: 'is_trailer', type: 'boolean', width: '10%'},
    {text: 'Actief', value: 'is_active', type: 'boolean', width: '10%'}
  ]
};
